import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { incidentOperations } from '../../../redux/incident';
import { withRouter } from 'react-router-dom';
// import IncidentHistoryDataGrid from "./IncidentHistoryDataGrid";
import IncidentHistoryTimeline from './IncidentHistoryTimeline';
import { formatAttribute } from '../../../utils/helpers';

import gridDefinition from '../../../defaults/datagrids/incidentHistory.json';
import originFields from '../../../defaults/PointOfOriginFields.json';

class IncidentHistory extends Component {
  constructor() {
    super();
    this.state = {
      loading: null,
      incidents: [],
      isMore: true,
      incidentCount: 0,
      showDataGrid: false
    };
  }

  updateIncidentList = (incidents, incidentCount, isMore, dataGridOptions) => {
    this.props.setHistoryIncidents({
      incidents
    });
    this.props.setHistoryIncidentCount({
      incidentCount
    });
    this.props.setHistoryIsMore({
      isMore
    });
    this.incidentsHaveLoaded();
    this.getStats(incidents, incidentCount);
  };

  getStats = (incidents, count) => {
    const totalUpdates = count;
    const modifiedBySystems = [
      ...new Set(
        incidents.map(incident => incident.attributes.ModifiedBySystem)
      )
    ];
    this.props.setCurrentIncidentStats({ totalUpdates, modifiedBySystems });
  };

  incidentsHaveLoaded = () => {
    this.props.setHistoryLoading({ loading: false });
  };

  incidentsAreLoading = () => {
    this.props.setHistoryLoading({ loading: true });
  };

  getBaseQuery() {
    const id = originFields.idFields.incidents;
    const value = this.props.match.params.id;
    const baseClause = gridDefinition.baseQuery
      ? `AND (${gridDefinition.baseQuery})`
      : '';
    return `(${id} = '${value}') ${baseClause}`;
  }

  getAllFields() {
    const fieldInfos = this.props.incidentHistoryFields;
    const incidentFieldsWithAliases = this.props.incidentFields;
//console.log(fieldInfos);
    const tempFields = Object.keys(fieldInfos)
      .filter(key => gridDefinition.ignoreFields.indexOf(key) === -1)
      .map(key => {
        const alias =
          incidentFieldsWithAliases[key] && incidentFieldsWithAliases[key].alias
            ? incidentFieldsWithAliases[key].alias
            : fieldInfos[key].alias;

        return { alias, name: key, width: 250 };
      })
      .sort((a, b) => {
        // alpha sort by field name
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

    const modField = tempFields.find(
      fieldInfo => fieldInfo.name === 'ModifiedOnDateTime'
    );

    const fields = tempFields.filter(
      fieldInfo => fieldInfo.name !== 'ModifiedOnDateTime'
    );
    fields.unshift(modField);

    return fields;
  }

  updateView = value => {
    this.props.setHistoryShowDataGrid({
      showDataGrid: value === 'datagrid'
    });
  };

  getCsvData = () => {
    const features = this.props.incidentHistory.incidents;
    let flatIncidents = features.map(featureObj => {
      const formattedAttributes = {};
      for (var key in featureObj.attributes) {
        if (featureObj.attributes.hasOwnProperty(key)) {
          const formattedAttribute = formatAttribute(
            key,
            featureObj.attributes[key],
            'incidentHistory',
            this.props.incidentHistoryFields,
            true
          );
          const { name, value } = formattedAttribute;
          formattedAttributes[name] = value || '';
        }
      }
      return { ...formattedAttributes };
    });

    return Promise.resolve(flatIncidents);
  };

  getHistoryGrid = (showDataGrid, incidentHistoryProps) => {
    return <IncidentHistoryTimeline {...incidentHistoryProps} />;
  };

  render() {
    const {
      loading,
      incidents,
      incidentCount,
      isMore
    } = this.props.incidentHistory;
    const { dataGridOptions } = this.props.appConfig;
    const mapLoaded = this.props.map.loaded;

    if (!mapLoaded) {
      return null;
    }

    const incidentHistoryProps = {
      ...this.props,
      loading,
      incidents,
      incidentCount,
      isMore,
      dataGridOptions,
      mapLoaded,
      fieldDefinitions: this.getAllFields(),
      baseQuery: this.getBaseQuery(),
      updateIncidentList: this.updateIncidentList,
      incidentsAreLoading: this.incidentsAreLoading,
      incidentsHaveLoaded: this.incidentsHaveLoaded,
      getCsvData: this.getCsvData,
      formatAttribute: formatAttribute
    };

    return <IncidentHistoryTimeline {...incidentHistoryProps} />;
  }
}

const mapStateToProps = state => ({
  map: state.map,
  appConfig: state.config,
  incidentHistoryFields: state.incident.historyFields,
  incident: state.incident.currentIncident,
  incidentHistory: state.incident.history,
  incidentFields: state.incident.fields,
  dataGridFilters: state.dataGridFilters
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...incidentOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IncidentHistory)
);



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncidentHistory.js